/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from '@/shared/api/axios-client'
import type { GetUsersQueryResponse, GetUsers400 } from '../entities/GetUsers'
import type { RequestConfig, ResponseErrorConfig } from '@/shared/api/axios-client'
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query'
import { getUsers } from '../api/getUsers'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getUsersQueryKey = () => [{ url: '/users' }] as const

export type GetUsersQueryKey = ReturnType<typeof getUsersQueryKey>

export function getUsersQueryOptions(config: Partial<RequestConfig> & { client?: typeof client } = {}) {
  const queryKey = getUsersQueryKey()
  return queryOptions<GetUsersQueryResponse, ResponseErrorConfig<GetUsers400>, GetUsersQueryResponse, typeof queryKey>({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal
      return getUsers(config)
    },
  })
}

/**
 * @description Получение списка пользователей
 * @summary Получение списка пользователей
 * {@link /users}
 */
export function useGetUsers<TData = GetUsersQueryResponse, TQueryData = GetUsersQueryResponse, TQueryKey extends QueryKey = GetUsersQueryKey>(
  options: {
    query?: Partial<QueryObserverOptions<GetUsersQueryResponse, ResponseErrorConfig<GetUsers400>, TData, TQueryData, TQueryKey>> & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: typeof client }
  } = {},
) {
  const { query: { client: queryClient, ...queryOptions } = {}, client: config = {} } = options ?? {}
  const queryKey = queryOptions?.queryKey ?? getUsersQueryKey()

  const query = useQuery(
    {
      ...(getUsersQueryOptions(config) as unknown as QueryObserverOptions),
      queryKey,
      ...(queryOptions as unknown as Omit<QueryObserverOptions, 'queryKey'>),
    },
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<GetUsers400>> & { queryKey: TQueryKey }

  query.queryKey = queryKey as TQueryKey

  return query
}